export enum SMSSubjects {
  Confirmed = 'ad_hoc'
}

export enum BookingStatus {
  Confirmed = 1,
  Assigned = 2,
  Cancelled = 3,
  Completed = 4,
  UnableToComplete = 5,
  RecallProposal = 6,
  RecallProposalClosedUserCreatedNormalBooking = 7
}

export const BOOKING_STATUS_OPTIONS = [
  { value: BookingStatus.Confirmed, label: 'Confirmed' },
  { value: BookingStatus.Assigned, label: 'Assigned' },
  { value: BookingStatus.Cancelled, label: 'Cancelled' },
  { value: BookingStatus.Completed, label: 'Completed' },
  { value: BookingStatus.UnableToComplete, label: 'Unable to complete' },
  { value: BookingStatus.RecallProposal, label: 'Recall proposal' },
  {
    value: BookingStatus.RecallProposalClosedUserCreatedNormalBooking,
    label: 'Recall proposal closed user created normal booking'
  }
];

export const SalesItemTypes = {
  Primary: { value: 0, name: 'Primary' },
  Addon: { value: 1, name: 'Addon' },
  ExtraCharge: { value: 2, name: 'Extra charge' },
  LegacyBundle: { value: 3, name: 'Legacy bundle' },
  Internal: { value: 4, name: 'Internal' }
} as const;

export const salesItemsTypeOptions = Object.values(SalesItemTypes).map(({ value, name }) => ({ value, label: name }));

export enum SalesItemCategory {
  WHEEL_CHANGE = 'WHEEL_CHANGE',
  WHEEL_STORAGE = 'WHEEL_STORAGE',
  CAR_WASH = 'CAR_WASH',
  SHOP_TIRE = 'SHOP_TIRE',
  SHOP_RIM = 'SHOP_RIM',
  SHOP_TIRE_GENERIC = 'SHOP_TIRE_GENERIC',
  SHOP_RIM_SALE_GENERIC = 'SHOP_RIM_SALE_GENERIC'
}

export enum CapacityContributionStatusEnum {
  Pending = 0,
  Submitted = 1,
  WaitList = 2,
  Reserved = 3,
  Declined = 4,
  Withdrawn = 5,
  Unassigned = 6,
  Assigned = 7
}
